import { Link } from "react-router-dom";
import { Reveal, Stagger, StaggerItem } from "../components/Motion";
import { academyTracks, doctor } from "../lib/data";
import { ArrowRight, GraduationCap } from "lucide-react";

export default function Academy() {
  return (
    <div data-testid="page-academy">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="overline mb-6">Академія</div>
            </Reveal>
            <Reveal delay={0.05}>
              <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight">
                Навчання для<br />косметологів
              </h1>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
                Авторські протоколи, постановка руки, індивідуальне навчання та підвищення
                кваліфікації для медичних спеціалістів. Три напрямки — інʼєкційна косметологія,
                терапія зниження ваги та крапельна терапія.
              </p>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-5">
            <img loading="lazy" decoding="async" src="/generated/teaching.webp"
              onError={(e) => (e.currentTarget.src = doctor.photos.clinicDesk)}
              alt="Навчання"
              className="w-full h-[480px] object-cover rounded-3xl"
            />
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-luxe space-y-6">
          <Stagger className="space-y-6">
            {academyTracks.map((t, i) => (
              <StaggerItem key={t.slug}>
                <div
                  data-testid={`academy-track-${t.slug}`}
                  className="group relative overflow-hidden rounded-3xl border border-line bg-bone p-8 md:p-12"
                >
                  <div className="grid lg:grid-cols-12 gap-8 items-start">
                    <div className="lg:col-span-4">
                      <div className="overline mb-3 text-warmGray">Напрямок {String(i + 1).padStart(2, "0")}</div>
                      <h2 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight">
                        {t.title}
                      </h2>
                      <Link
                        to="/booking"
                        state={{ procedure: t.title }}
                        data-testid={`academy-book-${t.slug}`}
                        className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase border-b border-ink pb-1"
                      >
                        Записатися на навчання <ArrowRight size={14} strokeWidth={1.5} />
                      </Link>
                    </div>
                    <div className="lg:col-span-8">
                      <ul className="grid md:grid-cols-2 gap-x-8 gap-y-2">
                        {t.items.map((it) => (
                          <li key={it} className="flex items-start gap-3 py-3 border-b border-line text-sm md:text-base">
                            <GraduationCap size={16} strokeWidth={1.2} className="mt-1 text-warmGray shrink-0" />
                            <span>{it}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
